<template>
  <section v-loading="loading" element-loading-text="跳转中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <Header :state="state"></Header>
    <div class="content_wrap" v-if="orderStatus">
      <div class="form_wrap">
        <div class="form_title">瑞森安全{{setMealObj.productName}}产品服务</div>
        <div class="from_content">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="购买套餐" prop="name" class="input_name"><span>{{setMealObj.productName}} {{setMealObj.price}}元/年</span></el-form-item>
            <el-form-item label="手机号码" prop="phoneNumber" class="itemWdith">
              <el-input v-model="ruleForm.phoneNumber" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="verCode" class="itemWdith input_code">
              <el-input v-model="ruleForm.verCode" maxlength="4"></el-input>
              <span @click="handleGetCode" v-show="show">获取验证码</span>
              <span v-show="!show" style="pointer-events:none;">{{count}}s</span>
            </el-form-item>
            <el-form-item label="支付方式" prop="name" class="methods_row">
              <div class="item_pay_content">
                <div v-if="index>0" class="item_pay_subItem" :class="{'active':payCurrent==index}" v-for="(item,index) in payData" :key="index" @click="handlePayItem(item,index)"><img :src="item.url" alt=""><span>{{item.name}}</span></div>
              </div>
            </el-form-item>
            <div class="desc_row">
              <div class="desc_content">
                <p class="desc_p1" style="margin-bottom:8px;"><span>订单金额</span>￥{{setMealObj.price}}</p>
                <p class="desc_p2">付款成功后，可申请发票 | 支付即代表你同意 <span @click="formVisible=true">《瑞森用户使用协议》</span></p>
              </div>
            </div>
            <el-form-item class="btn_row">
              <el-button type="primary" :disabled="isDisabledSubmitBtn" @click="submitForm('ruleForm')">立即支付</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="paymentCode" v-if="wxStatus">
      <img src="/static/images/banner.png" alt="">
    </div>
    <div class="paymentZFB" v-if="zfbStatus">
      <div class="content" v-html="zfbHtml" ref="alipayWap"></div>
    </div>
    <!--end表格内容end-->
    <el-dialog title="瑞森用户使用协议" :close-on-click-modal="false" :visible.sync="formVisible">
      <div class="agreementCon" style="border:1px solid #eee;padding:10pt;height:350pt;overflow-y: scroll;margin-bottom:15pt;">
        <p class="bold">前言</p>
        <p>感谢选择瑞森，在您选择使用瑞森提供的产品和服务前，请您务必先仔细阅读、充分理解本协议各条款内容（下称“服务条款”），特别是免除或者限制责任的条款、管辖与法律适用条款，以及开通或使用某项产品或服务的单独协议。一旦您完成“同意条款并注册”或开始以其他的方式使用瑞森服务，即表示您已经阅读并同意接受本服务条款的约束，如您不同意本服务条款的约束或其中任何条款的约定，您应该不再进行下一步或停止注册程序。您对本协议的同意即视为您已知悉并同意本协议全部条款并且您保证能够完全遵守本协议。</p>
        <p>如果用户未满18周岁，请在法定监护人的陪同下阅读本协议。</p>
        <p class="bold">前言</p>
        <p class="bold">一、 总则</p>
        <p>1.1 本服务条款是您与北京瑞森永安科技有限公司及其子/分公司（“瑞森”或者“我们”）关于您注册使用瑞森相关产品或服务所订立对双方具有约束力的有效契约。</p>
        <p>1.2 本协议项下的服务是指瑞森向您提供的包括但不限于目前已经推出的SaaS服务产品、及后续瑞森可能推出的纳入服务范畴内的其他服务产品及服务，瑞森截止目前已经推出的产品及服务可参见瑞森官方网站（ www.risensafe.com、www.risafety.com,下称“瑞森网站”）上所列。本服务中瑞森客户端软件提供包括但不限于Windows、Mac、iOS、Android等多个应用版本（具体以瑞森提供的版本为准），用户必须选择与所安装终端设备相匹配的软件版本。瑞森会不断更新应用版本。本协议自动适用于用户所使用的瑞森所有版本的客户端软件和服务。</p>
        <p>1.3 您通过注册、登录瑞森可操作购买而获得对应的服务，瑞森将不断创新致力于向您提供更优体验，您了解并同意瑞森提供的服务形式和本质可不经事先通知您而不时变换。</p>
        <p>1.4 瑞森有权依照本协议约定方式就本协议的内容进行变更。一旦本协议和/或有关服务内容发生变动，瑞森将通过网页公告、电子邮件、站内信、短信等其中任何一种或多种方式予以公告或通知，若您在本协议相关内容变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的条款内容。</p>
        <p>1.5 请您不时关注本协议及本协议项下服务有关内容，以便掌握相关变动情况。如果您不同意瑞森变更的内容，您可以主动取消相应的服务。如果您在变更内容通告后30天内未主动取消本协议项下服务则视为接受本协议和/或有关服务的变更；变更内容通告后您如果仍继续使用瑞森提供的服务亦构成对有关变更的接受。如您针对变更内容有异议，应在上述约定期限内主动取消本协议项下服务。</p>
        <p class="bold">二、 账户的获取与使用</p>
        <p>2.1 为了使用本协议项下服务，您必须完成相应的账户注册程序并获得相应账户。</p>
        <p>2.2 目前瑞森允许一个企业法律主体拥有多个瑞森账户，但一个瑞森账户仅能对应唯一的企业法律实体。除非经过瑞森书面同意，否则您的该账户不可转让、不可赠与、不可继承。</p>
        <p>2.3 您承诺以真实身份开通本协议下瑞森账户，且是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织，依据法律规定和本协议约定对所提供的信息承担相应的法律责任。</p>
        <p>2.4 您在申请使用本协议项下服务时，请按照瑞森提示向瑞森提供真实、准确的注册资料。如注册资料有任何变动，请您及时更新，如因您未及时、准确、完整更新有关信息给您带来的任何损失或增加费用及其他法律责任全部由您自行承担。请您务必提供真实信息，瑞森有权自行或委托第三方，审查您提供的身份信息是否真实、有效。若提供虚假信息，由此带来的全部结果由您承担。</p>
        <p>2.5 您账户和密码应由您妥善保管，并正确、安全地使用，因您未能保管好该账户和密码而导致的法律责任由您全部承担。若因为您自身原因，而导致账号、密码遭他人非法使用时，瑞森不负责处理。您自身原因包括但不限于：任意向第三者透露账号和密码及所有注册资料；多人共享同一个账号；安装非法或来路不明的程序；将已经登陆账号的设备提供给他人使用等。</p>
        <p>2.6 若您的授权代表签订本协议，瑞森将视该授权代表具备您的合法有效授权，您应对授权代表的行为承担责任。如若有任何第三方向瑞森发出指示，在确认其提供账户、密码信息准确的情况下，您同意且瑞森有权视为该行为获得了您的充分授权，该行为所产生结果直接归属于您本身。</p>
        <p>2.7 如您发现有他人冒用或盗用您的账户及密码或有使用异常情形的，您应立即以有效方式通知瑞森，您有权要求瑞森暂停相关账户的登录和使用。在瑞森采取措施之前，瑞森对此不负任何责任。</p>
        <p>2.8 您理解并同意，瑞森有权按照国家司法、行政、军事、安全等机关（包括但不限于法院、检察机关、公安机关等）的要求对您的企业/个人信息及在瑞森网站的资金、交易及账户等进行查询、冻结或划扣等操作。</p>
        <p class="bold">三、账户的冻结、注销及申诉</p>
        <p>3.1 账户的冻结您的瑞森账户（全部或部分权限或功能）在如下情况可能被冻结（如瑞森账户被限制使用等），瑞森将通过邮件、站内信、短信或电话等方式通知您：</p>
        <p>3.1.1 基于瑞森网站或服务运行和交易安全的需要，如您发生或可能发生破坏或试图破坏瑞森或瑞森关联公司产品形态/网络秩序的，或任何使用含有瑞森或瑞森关联公司名称、品牌且对他人有误导嫌疑或任何使用某种中英文(全称或简称)、数字、域名等意图表示或映射与瑞森或其关联公司具有某种关联的；</p>
        <p>3.1.2 违反本服务条款、瑞森网站的相关规则、规范（如交易规则、管理规范）、服务说明以及其他服务协议/条款的；</p>
        <p>3.1.3 违反国家法律、法规、政策、法律文书的规定的；</p>
        <p>3.1.4 您遭到他人投诉，且对方已经提供了相关证据的，而您未按照我们的要求提供相反证据的；</p>
        <p>3.1.5 瑞森根据合理分析判断您的账户操作存在异常的；</p>
        <p>3.1.6 国家有权机关要求进行的冻结的；</p>
        <p>3.1.7 瑞森合理判断，您发生与如上行为性质相同或产生如上类似风险的其他情况的。</p>
        <p class="bold">3.2 账户的注销</p>
        <p>3.2.1 如果出现如上第3.1条情形且情形严重的，或基于国家有权机关的要求，您的瑞森账户（全部或部分权限或功能）将被注销，瑞森将通过邮件、站内信、短信或电话等方式通知您。</p>
        <p>3.2.2 您理解并同意，如您连续12个月未通过账户登录过瑞森网站，且您的账户下不存在任何未到期的服务，瑞森有权注销您的账户，您将不能再登录瑞森网站。</p>
        <p>3.3 申诉发生前述账户冻结或注销情况下，您应及时予以关注并可以按照程序进行申诉等后续操作：</p>
        <p>3.3.1 您通过申诉程序，向瑞森申请解除上述冻结或注销的，为了您的账户安全，您应配合如实提供身份证明及相关资料，以及瑞森要求的其他信息或文件，以便瑞森进行核实。您应充分理解您的申诉并不必然被允许，瑞森有权决定是否同意您的申诉请求。</p>
        <p>3.3.2 您理解并同意，如果您拒绝如实提供身份证明及相关资料，或未能通过瑞森审核，瑞森有权长期冻结该等账户且长期限制账户部分或全部功能。</p>
        <p class="bold">四、电子签名使用须知</p>
        <p>电子签名数字证书是瑞森向CA认证机构北京天威诚信电子商务服务有限公司（以下简称“天威诚信”）申请为您颁发的用于识别您身份的数字证书，为确保电子签名数字证书的正确签发和使用，为更好地为您提供规范的服务，保障您的权益，请您于申请电子签名数字证书前，仔细阅读下列使用须知：</p>
        <p>4.1 电子签名数字证书是指电子签名个人或企业数字证书（以下简称“数字证书”）。</p>
        <p>4.2 请您按照瑞森规定的数字证书申请流程提供有关资料，并保证所填写的注册信息和所提供的资料的真实性、准确性和完整性，否则瑞森有权拒绝您的申请请求。</p>
        <p>4.3 如数字证书信息在数字证书有效期限内变更的，您应当及时书面告知瑞森，并终止使用该数字证书。</p>
        <p>4.4 您已同意瑞森和天威诚信向有关部门和个人核实您的信息。瑞森和天威诚信有权合法收集、处理、传递及应用您的资料，并按照国家有关规定及本协议的约定对您资料保密。</p>
        <p>4.5 您独立享有数字证书的使用权，同时因使用数字证书产生的义务、责任由您自行承担。</p>
        <p>4.6 数字证书应当在有效期限内使用。</p>
        <p>4.7 数字证书有效期限届满，您需要继续使用的，应当与瑞森办理数字证书更新手续。</p>
        <p>4.8 您应当妥善保管数字证书私钥。如因您原因致使数字证书私钥泄露、损毁或者丢失的，损失由您自行承担。</p>
        <p>4.9 如数字证书私钥在数字证书有效期内损毁、丢失、泄露的，您应当及时向瑞森申请办理吊销手续。吊销自手续办妥时起生效。吊销生效前发生的损失由您承担。</p>
        <p>4.10 您知悉数字证书私钥已经丢失或者可能已经丢失时，应当及时告知瑞森，协助瑞森完成吊销该数字证书的工作，并终止使用该数字证书。</p>
        <p>4.11.1 您向瑞森提供的资料或者信息不真实、不完整或者不准确的。</p>
        <p>4.11.2 数字证书的信息有变更，您未终止使用该数字证书并通知瑞森的。</p>
        <p>4.11.3 您已知悉数字证书私钥丢失或者可能丢失时，未终止使用该数字证书并通知瑞森的。</p>
        <p>4.11.4 您超过数字证书的有效期限但仍使用数字证书的。</p>
        <p>4.11.5 您将数字证书用于违法、犯罪活动的。</p>
        <p>4.12 因设备故障、电力故障及通讯故障或者电脑病毒、自然灾害等因素造成您损失的，瑞森不承担任何责任。</p>
        <p>4.13 瑞森有下列情形并对您造成损失的，瑞森向您承担赔偿责任：</p>
        <p>4.13.1 由于瑞森原因导致将数字证书签发给您以外的第三方的。</p>
        <p>4.13.2 由于瑞森原因导致数字证书中的信息错误的。</p>
        <p>4.13.3 由于瑞森原因导致数字证书私钥被破译的。您应当在以上情形出现之日起1年内向瑞森提出赔付申请。逾期不申请的，视为您放弃请求瑞森赔付的权利。</p>
        <p>4.14 您向瑞森提出赔付申请时，应当提交下列材料并协助瑞森完成相应的调查工作：</p>
        <p>4.14.1 能够证明您身份的材料，如：身份证、护照、企业法人营业执照等。</p>
        <p>4.14.2 能够证明您遭受损失的材料。</p>
        <p>4.14.3 能够证明瑞森有过错的材料。</p>
        <p>4.14.4 其他应当提交的材料。</p>
        <p>4.15 瑞森有权以在互联网上公开发布的方式修改本使用须知，如您拒绝修改，应在公布后30日内向瑞森提出异议并与瑞森协商达成一致。否则视为您接受修改。</p>
        <p class="bold">五、 您的权利义务及使用规范</p>
        <p>5.1 未经瑞森事先书面同意，您不得将您在本协议项下的权益转让给第三方；您自有设备上需要的软件版本、许可或者使用权由您自行解决并独立承担相应法律责任。</p>
        <p>5.2 如您从事的业务需要获得经营资质，您应在使用服务前及时办妥此类手续并取得合法经营资格，如有必要的，需向瑞森提供相关书面证明。</p>
        <p>5.3 您应根据您的需求自行开通或删除相应资源，您应承担服务开通期间而产生的所有服务费用。</p>
        <p>5.4 瑞森向您提供的任何资源、技术支持和服务等，您除用于自身及自身经营业务外无权将该等资源、技术支持及服务转让、许可、赠与或以任何其他方式提供给他人使用/利用。</p>
        <p>5.5 在通过本协议项下服务网站使用本协议项下服务时，您不得：利用本协议项下服务网站或本协议项下服务进行任何可能对互联网或移动网正常运转造成不利影响的行为；利用本协议项下服务网站或本协议项下服务上传、存储、展示、复制、发布、传播、分享或以其他方式传送含有任何非法的和不道德的信息数据或者违法上传、存储并分享他人作品。</p>
        <p>5.6 您应遵守中华人民共和国相关法律法规。您保证不得将本协议项下服务作下述使用：</p>
        <p>(1) 反对中华人民共和国宪法所确定的基本原则的；</p>
        <p>(2) 危害国家统一、主权和领土完整的；</p>
        <p>(3) 泄露国家秘密，危害国家安全或者损害国家荣誉和利益的；</p>
        <p>(4) 煽动民族仇恨、民族歧视，破坏民族团结或者侵害民族风俗、习惯的；</p>
        <p>(5) 破坏国家宗教政策，宣扬邪教、迷信的；</p>
        <p>(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p>(7) 散布淫秽、赌博、暴力或者教唆犯罪的；</p>
        <p>(8) 侮辱或者诽谤他人，实施诈欺、虚伪不实或误导行为，或利用瑞森服务侵害他人合法权益；</p>
        <p>(9) 危害社会公德或者民族优秀文化传统的；</p>
        <p>(10) 侵犯他人知识产权、人身权或其他合法权益以及有违社会公序良俗的内容或指向这些内容的链接；</p>
        <p>(11) 进行涉嫌“私服”、“外挂”等非法互联网活动；</p>
        <p>(12) 发布、传送、传播不受欢迎的或者未经请求的电子邮件、电子广告或包含反动、色情等有害信息的电子邮件；</p>
        <p>(13) 违反与瑞森网络相联通之网络、设备或服务的操作规定；</p>
        <p>(14) 进行任何改变或试图改变瑞森及/或瑞森合作方提供的系统配置或破坏系统安全的行为，包括但不限于以病毒、木马、恶意代码、钓鱼等方式，对网站、服务器进行恶意扫描、非法侵入、非法获取数据等；</p>
        <p>(15) 建立或利用有关设备、配置运行与所使用服务无关的程序或进程，导致大量占用服务器内存、CPU或者网络带宽资源，给瑞森的系统或者其他客户所使用的网络、服务器、产品/服务等带来严重的负荷，影响瑞森服务与互联网或者与特定网络、服务器及瑞森服务内部的通畅联系，或者导致您自己或他人的服务器宕机、死机或者他人的产品或服务不可访问等；</p>
        <p>(16) 利用技术或其他手段破坏、扰乱瑞森服务的运营或他人使用瑞森服务；</p>
        <p>(17) 以任何方式干扰或企图干扰瑞森任何产品或任何部分、功能的正常运行，或者制作、发布、传播上述工具、方法等；</p>
        <p>(18) 因从事“DNS解析”、“安全服务”、“域名代理”、“反向代理”等任何业务，导致客户自己频繁遭受攻击（包括但不限于DDoS攻击）且未及时更正行为，或未根据瑞森要求消除影响，从而对瑞森服务平台或他人产生影响的；</p>
        <p>(19) 故意或非故意违反任何相关现行有效法律；</p>
        <p>(20) 收集和储存其他使用者之个人资料；</p>
        <p>(21) 其他瑞森认为有害或不当行为；</p>
        <p>(22) 法律、行政法规禁止的其他内容。</p>
        <p>5.7 如果您通过使用本协议项下服务，将获取使用来自第三方的产品或服务，您还可能受限于该等第三方的有关条款和条件，瑞森对此不予过问亦不承担任何责任，本协议不影响您与该第三方的法律关系。</p>
        <p>5.8 您确认并同意，瑞森的各关联公司均为本协议项下服务条款的第三方受益人，且瑞森关联公司有权直接强制执行并依赖本协议项下条款中授予其利益的任何规定。</p>
        <p class="bold">六、 隐私政策</p>
        <p>6.1 您的信任对瑞森非常重要，瑞森深知用户信息安全的重要性，瑞森将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。具体详见《瑞森隐私保护政策》。</p>
        <p class="bold">七、 知识产权</p>
        <p>7.1 除非瑞森另行说明，瑞森网站Logo、“瑞森”等文字、图形及其组合，以及瑞森网站的其他标识、瑞森服务的名称、技术文档等的知识产权为瑞森及其关联公司所有。</p>
        <p>7.2 瑞森尊重您的知识产权，除非获得了您的同意，瑞森不会擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表您拥有知识产权的成果。</p>
        <p class="bold">八、保密</p>
        <p>瑞森承诺对您注册账户时或使用瑞森服务时提交或知悉的信息采取保密措施，不向第三方披露您的信息，除非：</p>
        <p>8.1 依据本服务条款或者您与瑞森之间其他服务协议、合同、在线条款等规定可以提供的；</p>
        <p>8.2 依据法律法规的规定或行政、司法等职权部门要求应当提供的；</p>
        <p>8.3 在不违反本服务条款约定责任的前提下，该保密信息已经公开或能从公开领域获得。</p>
        <p class="bold">九、 责任范围及责任限制</p>
        <p>9.1 由于您行为所导致或产生的任何处罚、调查、指控、索赔或要求，或由此导致任何损失，均需您自行承担费用解决，并自行承担相应责任。如因您的行为导致任何第三方针对瑞森包括瑞森的供货商、客户或员工提出任何处罚、调查、指控、索赔或要求，您应承担相应责任，同时瑞森保留就您的行为给瑞森导致的损失向您索赔的权利。</p>
        <p>9.2 瑞森仅对本协议中明确载明的责任范围承担责任。瑞森对通过您间接接受瑞森服务的第三方、您的终端用户的损失不承担任何责任。</p>
        <p>9.3 瑞森在此提示，您在使用瑞森服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用瑞森的服务从事侵犯他人名誉、隐私、知识产权和其他合法权益的活动。瑞森不对您使用瑞森服务的违法或违约行为承担任何责任。</p>
        <p>9.4 因您未提供本协议项下有关服务产品开通的必要条件而使服务产品、服务无法提供或延期提供或造成服务产品、服务品质缺陷的，瑞森不承担相关责任。</p>
        <p>9.5 如您在使用瑞森服务开展相应业务过程中，因您的具体业务原因需要遵守当地法律法规的，请您履行当地的相关规定。您应自行承担因您未遵守相应规定给您造成的损失，且您应承担因此给瑞森造成的损失（如有）。</p>
        <p class="bold">十、 出口管制</p>
        <p>10.1 双方承诺遵守本协议所适用的联合国、中国、美国以及其他国家出口管制法律法规。您承诺不会将瑞森提供的产品或服务用于适用的出口管制法律法规禁止的用途。非经相关主管机关许可，您及您授权使用瑞森产品或服务的其他个人或实体不会通过瑞森产品或服务向适用的出口管制法律法规禁止的实体或个人提供受管控的技术、软件或服务。</p>
        <p class="bold">十一、其他</p>
        <p>11.1 本服务条款由本服务条款的内容、网站相关页面上展现的规则、规范，服务说明（含操作文档）和您点击确认的其他条款/条件组成，瑞森和您均受其约束，且其中的相关名词可相互引用、解释。</p>
        <p>11.2 本服务条款的章节标题仅为行文方便而设，不具有法律或合同效力。</p>
        <p>11.3 本服务条款任一条款被视为废止、无效或不可执行，该条款应视为可分的且不影响本服务条款及其他条款的有效性及可执行性。</p>
        <p>11.4 瑞森有权在瑞森官网（www.risensafe.com/www.risafety.com）上发布公告、发站内通知或邮件通知等方式将本服务的权利义务全部或者部分转移给瑞森的关联公司。</p>
        <p>11.5 除另有约定外，出于服务专业性考虑，瑞森亦可能委托关联公司或其他法律主体向您提供瑞森网站上一项或多项具体服务，同时您可能会与该等公司订立相关条款或条件，请您审慎阅读、充分理解条款和条件内容，选择接受或不接受该条款和条件。</p>
        <p>11.6 本服务条款项下之保密条款、知识产权条款、法律适用与管辖条款以及性质上理应存续的其他条款（如对注册信息的真实性保证等），不因本条款的终止而失效。</p>
        <p>11.7 一方免予追究另一方一次或多次未履行本协议义务相关责任的，不得被解释为对任何随后的违反协议或不履行本协议责任的不予追究。一方于另一方违约后继续履行本协议的，不得被视为对另一方违约责任的免于追究。</p>
        <p>11.8 您对服务之任何部分或本协议的任何部分之意见及建议可通过客户服务部门与瑞森联系。</p>
        <p>11.8 请点击www.risensafe.com/www.risafety.com查看客服联系方式。</p>
      </div>
    </el-dialog>
    <Footer></Footer>
  </section>
</template>
<script>
import Header from '../components/common/header'
import Footer from '../components/common/footer'
export default {
  name: 'home',
  components: { Header,Footer },
  data () {
    var checkPhoneNumber = (rule, value, callback) => {
      var reg = /^1[3|4|5|8|7|6][0-9]\d{4,8}$/;
      if (value) {
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号码'));
        }
      } else {
        return callback(new Error('请输入手机号码'));
      }
    };
    var checkVerCode = (rule, value, callback) => {
      var reg = /^\d{4}$/;
      if (value) {
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的验证码'));
        }
      } else {
        return callback(new Error('请输入验证码'));
      }
    };
    return {
      state:1,
      formVisible: false,
      ruleForm:{
        phoneNumber:'',
        verCode:''
      },
      rules:{
        phoneNumber: [
          {validator: checkPhoneNumber, trigger: 'blur'}
        ],
        verCode: [
          {validator: checkVerCode, trigger: 'blur'}
        ],
      },
      payCurrent:1,
      payData:[{url:'/static/images/small2.png',name:'微信支付'},{url:'/static/images/small1.png',name:'支付宝'},{url:'/static/images/small3.png',name:'对公转账'}],
      isDisabledSubmitBtn:false,
      orderStatus:true,
      zfbStatus:false,
      wxStatus:false,
      requestVerCode:'',
      setMealObj:{},
      timer: null,
      count: '',
      show: true,
      zfbHtml:'',
      loading:false,
      getState:0,
    }
  },
  created(){
    this.setMealObj = this.$route.params.setMealObj ? this.$route.params.setMealObj : JSON.parse(sessionStorage.getItem('setMealObj'));
  },
  methods:{
    handleGetCode(){//获取验证码
      let that=this;
      that.ruleForm.verCode='';
      if(that.ruleForm.phoneNumber){
        let reg = /^1[3|4|5|8|7|6][0-9]\d{4,8}$/;
        if(reg.test(that.ruleForm.phoneNumber)){
          that.getState=1;
          that.countDownFun();
          that.$http.post('/api/product/send-verify-code', {mobile:that.ruleForm.phoneNumber}).then(res=>{
            console.log(res);
            if(res.data.code=='OK'){
              that.$message({type: 'success',message: '短信已发送'})
            }else{
              that.$message({type: 'error',message: res.data.message})
            }
          })
        }else{
          that.$message({type: 'error',message: '请输入正确的手机号码'})
        }
      }else{
        that.$message({type: 'error',message: '请输入手机号码'})
      }
    },
    countDownFun(){
      let that=this;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--;
          } else {
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
          this.ruleForm.verCode='';
          }
        }, 1000)
      }
    },
    handlePayItem(item,index){
      this.payCurrent=index;
    },
    submitForm(formName){
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if(that.getState==1){
            if(that.payCurrent==0){
              that.payDealFun('weixin');
            }else if(that.payCurrent==1){
              that.payDealFun('ali');
            }else{//支付宝
              that.payDealFun('account')
            }
          }else{
            that.ruleForm.verCode='';
            that.getState=-1;
            that.$message({type: 'error',message: '请获取验证码'})
          }
        }
      }) 
    },
    payDealFun(dealStr){
      let that=this;
      that.$http.post('/api/pay/payment', {productId:that.setMealObj.id,payType:dealStr,mobile:that.ruleForm.phoneNumber,verifyCode:that.ruleForm.verCode}).then(res=>{
        if(res.data.code=='OK'){
          if(dealStr=='weixin'){//微信
            that.zfbStatus=false;
            that.orderStatus=false;
            that.wxStatus=true;
          }else if(dealStr=='ali'){//支付宝
            that.loading=true;
            that.zfbHtml=res.data.data.form;
            that.zfbStatus=true;
            that.orderStatus=false;
            that.wxStatus=false;
            that.$nextTick(() => {
              that.$refs.alipayWap.children[0].submit()
            })
          }else{//转账
            if(res.data.code!='OK'){
              that.$message({type: 'error',message: res.data.message})
            }else{
              this.$router.push({path: '/transferPage', query: {orderId: this.$Base64.encode(JSON.stringify(res.data.data.form)),orderTotal:this.$Base64.encode(JSON.stringify(that.setMealObj.price))}});
            }
          }
        }else if(res.data.code=='10002'){
          that.$message({type: 'error',message:'请点击发送验证码/验证码错误'})
        }else{
          that.$message({type: 'error',message: res.data.message})
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.paymentCode{
  width: 100%;
  padding: 150px 0;
  text-align: center;
  vertical-align: middle;
  img{
    width: 300px;
    vertical-align: middle;
  }
}
.paymentZFB{
  width: 100%;
  padding: 150px 0;
  text-align: center;
  vertical-align: middle;
  .content{
    width: 200px;
    height: 200px;
    display: inline-block;
  }
}
.content_wrap{
  width: 100%;
  padding: 60px 0;
  .form_wrap{
    width: 60%;
    margin: 0 auto;
    height:837px;
    background:rgba(255,255,255,1);
    box-shadow:0px 13px 45px 0px rgba(210,210,210,0.5);
    border-radius:18px 18px 0px 0px;
    .form_title{
      widows: 100%;
      height: 90px;
      line-height: 90px;
      font-size: 24px;
      font-weight: 500;
      background:linear-gradient(90deg,rgba(88,158,255,1) 0%,rgba(28,108,246,1) 100%);
      box-shadow:0 13px 45px 0 rgba(210,210,210,0.5);
      border-radius:18px 18px 0 0;
      color: #ffffff;
    }
    .from_content{
      padding: 0 87px;
      height: 660px;
      padding-top: 46px;
      background: #ffffff;
      .demo-ruleForm{
        /deep/.el-form-item{
          margin-bottom: 46px;
        }
        /deep/.el-form-item:last-child{
          margin-bottom: 0;
        }
        /deep/.el-form-item__label{
          font-size:22px;
          font-weight:400;
          line-height:30px;
          color: #333333;
          font-weight: normal;
        }
        .el-form-item.input_name{
          /deep/.el-form-item__content{
            text-align: left;
            color: #333333;
            font-size: 22px;
            line-height: 30px;
          }
        }
        .itemWdith{
          width: 420px;
          .el-input{
            /deep/.el-input__inner{
              border-top: none;
              border-left: none;
              border-right: none;
              border-radius: 0;
            }
          }
        }
        .itemWdith.input_code{
          position: relative;
          span{
            font-size:0.14rem;
            line-height: 0.2rem;
            color: #333333;
            padding: 0 0.12rem;
            display: inline-block;
            border-left: 0.01rem solid #E0E0E0;
            position: absolute;
            right: 0;
            bottom: 0.1rem;
            cursor: pointer;
          }
        }
        .methods_row{
          /deep/.el-form-item__label{
            margin: 24px 0 0;
          }
          /deep/.el-form-item__content{
            .item_pay_content{
              height: 54px;
              margin-top: 12px;
              overflow: hidden;
              .item_pay_subItem{
                width: 260px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                vertical-align: middle;
                border-radius:9px;
                border: 1px solid #E0E0E0;
                float: left;
                margin-right: 23px;
                cursor: pointer;
                img{
                  height: 0.25rem;
                  width: 0.25rem;
                  vertical-align: middle;
                }
                span{
                  color: #333333;
                  font-size: 0.18rem;
                  margin-left: 0.1rem;
                  vertical-align: middle;
                }
              }
              .item_pay_subItem:hover,.item_pay_subItem.active{
                border: 1px solid #4566F5;
              }
              .item_pay_subItem:last-child{
                margin-right: 0;
              }
            }
          }
        }
        .desc_row{
          width: 970px;
          margin: 60px auto 0;
          border-top: 2px dashed #E0E0E0;
          .desc_content{
            width: 100%;
            margin-top: 60px;
            padding: 14px 0;
            background: #FAFAFA;
            border: 1px solid transparent;
            .desc_p1{
              text-align: right;
              margin: 0 40px 0 0;
              color: #FF1919;
              font-size: 30px;
              line-height: 40px;
              font-weight:500;
              span{
                color: #333333;
                font-size: 18px;
                font-weight: normal;
                margin-right: 14px;
              }
            }
            .desc_p2{
              color: #999999;
              font-size:18px;
              line-height: 24px;
              text-align: right;
              margin-right: 28px;
              font-weight: normal;
              span{
                color: #4566F5;
                margin-left: 18px;
                cursor: pointer;
              }
            }
          }
        }
        .btn_row{
          margin: 40px 0 0;
          text-align: right;
          .el-button{
            width: 224px;
            padding: 0;
            text-align: center;
            height: 70px;
            line-height: 70px;
            background: #4566F5;
            color: #ffffff;
            font-size:22px;
          }
          .el-button:hover,.el-button.active{
            opacity: 0.6;
          }
        }
      }
    }
  }
}
@media (min-width: 1024px){
  .content_wrap{
    width: 100%;
    padding: 0.6rem 0;
    .form_wrap{
      width: 60%;
      margin: 0 auto;
      height:9.5rem;
      background:rgba(255,255,255,1);
      box-shadow:0 0.13rem 0.45rem 0 rgba(210,210,210,0.5);
      border-radius:0.18rem 0.18rem 0 0;
      .form_title{
        widows: 100%;
        height: 0.9rem;
        line-height: 0.9rem;
        font-size: 0.24rem;
        font-weight: 500;
        background:linear-gradient(90deg,rgba(88,158,255,1) 0%,rgba(28,108,246,1) 100%);
        box-shadow:0 0.13rem 0.45rem 0 rgba(210,210,210,0.5);
        border-radius:0.18rem 0.18rem 0 0;
        color: #ffffff;
      }
      .from_content{
        padding: 0 0.87rem;
        height: 7.4rem;
        padding-top: 0.46rem;
        background: #ffffff;
        .demo-ruleForm{
          /deep/.el-form-item{
            margin-bottom: 0.5rem;
          }
          /deep/.el-form-item:last-child{
            margin-bottom: 0;
          }
          /deep/.el-form-item__label{
            font-size:0.22rem;
            font-weight:400;
            line-height:0.72rem;
            color: #333333;
            font-weight: normal;
          }
          .el-form-item.input_name{
            /deep/.el-form-item__content{
              text-align: left;
              color: #333333;
              font-size:0.22rem;
              line-height:0.72rem;
            }
          }
          .itemWdith{
            width: 7.2rem;
            .el-input{
              /deep/.el-input__inner{
                border-top: none;
                border-left: none;
                border-right: none;
                border-radius: 0;
              }
            }
          }
          .itemWdith.input_code{
            position: relative;
            span{
              font-size:14px;
              line-height: 20px;
              color: #333333;
              padding: 0 12px;
              display: inline-block;
              border-left: 1px solid #E0E0E0;
              position: absolute;
              right: 0;
              bottom: 10px;
              cursor: pointer;
            }
          }
          .methods_row{
            /deep/.el-form-item__label{
              margin: 0.04rem 0 0;
            }
            /deep/.el-form-item__content{
              .item_pay_content{
                height: 0.54rem;
                margin-top: 0.12rem;
                overflow: hidden;
                .item_pay_subItem{
                  width: 2.6rem;
                  height: 0.5rem;
                  line-height: 0.5rem;
                  text-align: center;
                  vertical-align: middle;
                  border-radius:0.09rem;
                  border: 0.01rem solid #E0E0E0;
                  float: left;
                  margin-right: 0.23rem;
                  cursor: pointer;
                  img{
                    height: 0.25rem;
                    vertical-align: middle;
                  }
                }
                .item_pay_subItem:last-child{
                  margin-right: 0;
                }
              }
            }
          }
          .desc_row{
            width: 9.7rem;
            margin: 0.6rem auto 0;
            border-top: 0.02rem dashed #E0E0E0;
            .desc_content{
              width: 100%;
              margin-top: 0.6rem;
              padding: 0.14rem 0;
              background: #FAFAFA;
              border: 0.01rem solid transparent;
              .desc_p1{
                text-align: right;
                margin: 0 0.4rem 0 0;
                color: #FF1919;
                font-size: 0.3rem;
                line-height: 0.4rem;
                font-weight:500;
                span{
                  color: #333333;
                  font-size: 0.18rem;
                  font-weight: normal;
                  margin-right: 0.14rem;
                }
              }
              .desc_p2{
                color: #999999;
                font-size:0.18rem;
                line-height: 0.24rem;
                text-align: right;
                margin-right: 0.28rem;
                font-weight: normal;
                span{
                  color: #4566F5;
                  margin-left: 0.18rem;
                  cursor: pointer;
                }
              }
            }
          }
          .btn_row{
            margin: 0.4rem 0 0;
            text-align: right;
            .el-button{
              width: 2.24rem;
              padding: 0;
              text-align: center;
              height: 0.7rem;
              line-height: 0.7rem;
              background: #4566F5;
              color: #ffffff;
              font-size:0.22rem;
              margin-right: 0.72rem;
            }
            .el-button:hover,.el-button.active{
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
} /*>=1024的设备*/
@media (min-width: 1100px) {
  body{font-size: 20px}
} /*>=1100的设备*/
// @media (min-width: 1366px) {
//   body{font-size: 24px;}
// }  
@media (min-width: 1280px) {
  body{font-size: 25px !important;}
  .desc_row{
    width: 92% !important;
    margin: 60px auto 0;
    border-top: 2px dashed #E0E0E0;
    .desc_content{
      width: 100%;
      margin-top: 60px;
      padding: 14px 0;
      background: #FAFAFA;
      border: 1px solid transparent;
      .desc_p1{
        text-align: right;
        margin: 0 40px 0 0;
        color: #FF1919;
        font-size: 30px;
        line-height: 40px;
        font-weight:500;
        span{
          color: #333333;
          font-size: 18px;
          font-weight: normal;
          margin-right: 14px;
        }
      }
      .desc_p2{
        color: #999999;
        font-size:18px;
        line-height: 24px;
        text-align: right;
        margin-right: 28px;
        font-weight: normal;
        span{
          color: #4566F5;
          margin-left: 18px;
          cursor: pointer;
        }
      }
    }
  }
}
@media (min-width: 1680px) {
  .content_wrap{
    width: 100%;
    padding: 60px 0;
    .form_wrap{
      width: 60%;
      margin: 0 auto;
      height:837px;
      background:rgba(255,255,255,1);
      box-shadow:0px 13px 45px 0px rgba(210,210,210,0.5);
      border-radius:18px 18px 0px 0px;
      .form_title{
        widows: 100%;
        height: 90px;
        line-height: 90px;
        font-size: 24px;
        font-weight: 500;
        background:linear-gradient(90deg,rgba(88,158,255,1) 0%,rgba(28,108,246,1) 100%);
        box-shadow:0 13px 45px 0 rgba(210,210,210,0.5);
        border-radius:18px 18px 0 0;
        color: #ffffff;
      }
      .from_content{
        padding: 0 87px;
        height: 660px;
        padding-top: 46px;
        background: #ffffff;
        .demo-ruleForm{
          /deep/.el-form-item{
            margin-bottom: 46px;
          }
          /deep/.el-form-item:last-child{
            margin-bottom: 0;
          }
          /deep/.el-form-item__label{
            font-size:22px;
            font-weight:400;
            line-height:30px;
            color: #333333;
            font-weight: normal;
          }
          .el-form-item.input_name{
            /deep/.el-form-item__content{
              text-align: left;
              color: #333333;
              font-size: 22px;
              line-height: 30px;
            }
          }
          .itemWdith{
            width: 420px;
            .el-input{
              /deep/.el-input__inner{
                border-top: none;
                border-left: none;
                border-right: none;
                border-radius: 0;
              }
            }
          }
          .methods_row{
            /deep/.el-form-item__label{
              margin: 24px 0 0;
            }
            /deep/.el-form-item__content{
              .item_pay_content{
                height: 54px;
                margin-top: 12px;
                overflow: hidden;
                .item_pay_subItem{
                  width: 4rem;
                  height: 50px;
                  line-height: 50px;
                  text-align: center;
                  vertical-align: middle;
                  border-radius:9px;
                  border: 1px solid #E0E0E0;
                  float: left;
                  margin-right: 23px;
                  cursor: pointer;
                  img{
                    height: 25px;
                    width: 25px;
                    vertical-align: middle;
                  }
                  span{
                    color: #333333;
                    font-size: 18px;
                    margin-left: 10px;
                    vertical-align: middle;
                  }
                }
                .item_pay_subItem:last-child{
                  margin-right: 0;
                }
              }
            }
          }
          .desc_row{
            width: 970px;
            margin: 60px auto 0;
            border-top: 2px dashed #E0E0E0;
            .desc_content{
              width: 100%;
              margin-top: 60px;
              padding: 14px 0;
              background: #FAFAFA;
              border: 1px solid transparent;
              .desc_p1{
                text-align: right;
                margin: 0 40px 0 0;
                color: #FF1919;
                font-size: 30px;
                line-height: 40px;
                font-weight:500;
                span{
                  color: #333333;
                  font-size: 18px;
                  font-weight: normal;
                  margin-right: 14px;
                }
              }
              .desc_p2{
                color: #999999;
                font-size:18px;
                line-height: 24px;
                text-align: right;
                margin-right: 28px;
                font-weight: normal;
                span{
                  color: #4566F5;
                  margin-left: 18px;
                  cursor: pointer;
                }
              }
            }
          }
          .btn_row{
            margin: 40px 0 0;
            text-align: right;
            .el-button{
              width: 224px;
              padding: 0;
              text-align: center;
              height: 70px;
              line-height: 70px;
              background: #4566F5;
              color: #ffffff;
              font-size:22px;
            }
            .el-button:hover,.el-button.active{
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
}
.agreementCon{
  text-align: left;
  h1{
    font-weight: 600;
    color: #333;
    text-align: center;
  }
  p{
    text-indent: 2em;
    line-height: 22pt;
  }
  .bold{
    font-weight: 600;
    color: #333;
    font-size: 16px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order.vue